import { ScButton } from 'components/buttons/Button/styled';
import { ScInput } from 'components/form/primitives/styled';
import { ScQRCode } from 'components/form/QRCode/styled';
import styled from 'styled-components/macro';

export const ScFieldExpiryDateRow = styled.div<{ $list?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $list }) =>
    $list ? `repeat(1, 1fr)` : `repeat(2, 1fr)`};
  grid-column-gap: 16px;
  grid-row-gap: 16px;
`;

export const ScShortAmount = styled.div`
  margin: 0 -2px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  button {
    .btn-content {
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.14px;
    }
  }
  & > * {
    margin: 8px 2px 0;
    font-size: 12px;
  }
`;

export const ScCryptoBlock = styled.div`
  margin-bottom: 8px;
  font-size: 14px;

  .text-copy {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.16px;
    font-weight: 700;
  }

  .address {
    background: ${({ theme }) => theme.blackColor};
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    overflow: hidden;

    .address-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      min-width: 0;
    }
  }

  ${ScQRCode} {
    margin-bottom: 32px;
  }

  .details {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0;
    margin: 8px 0;
  }

  .details-text {
    .wrapper {
      ${ScButton} {
        .btn-content {
          .code-box {
            display: flex;
            gap: 8px;
          }
        }
      }
      ${ScInput} {
        padding: 0 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .wrapper {
    display: grid;
    grid-template-columns: 1fr minmax(108px, auto);
    gap: 8px;
    margin-top: 16px;
  }
`;

export const ScCvvBlock = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 192px;
  .input {
    width: 100%;
    max-width: 160px;
  }
`;
